module.exports = __webpack_public_path__ + "static/media/csr_1_breast_cancer.58749fa8.jpg";